// extracted by mini-css-extract-plugin
module.exports = {"control":"pagination_control__Vrggi","dots":"pagination_dots__gBALF"};